/** @format */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Profile, Configuration } from '../models/profile';
import { UpdateMemberConfig, User } from '../store/application';

@Injectable({
	providedIn: 'root',
})
export class ProfileService {
	profileUrl = 'api/profile';
	graphMeEndpoint = 'https://graph.microsoft.com/v1.0';

	httpOptions = {
		headers: new HttpHeaders({
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		}),
	};

	constructor(private httpClient: HttpClient) {}

	getProfile(): Observable<Profile> {
		return this.httpClient.get<Profile>(this.profileUrl);
	}

	getADFilteredUsers(token: string, searchString: string): Observable<any> {
		return this.httpClient.get(`${this.graphMeEndpoint}/users?$search="displayName:${searchString}"&$orderby=displayName`, {
			headers: {
				Authorization: `Bearer ${token}`,
				ConsistencyLevel: 'eventual',
			},
		});
	}

	getADFilteredUserGroupMemberships(token: string, id: string): Promise<any> {
		return this.httpClient
			.get(`${this.graphMeEndpoint}/users/${id}/memberof`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.toPromise();
	}

	getUserAdProfile(token: string): Observable<any> {
		return this.httpClient.get(`${this.graphMeEndpoint}/me`, {
			headers: { Authorization: `Bearer ${token}` },
		});
	}

	getUserEmployeeId(token: string): Observable<any> {
		return this.httpClient.get(`${this.graphMeEndpoint}/me/employeeid`, {
			headers: { Authorization: `Bearer ${token}` },
		});
	}

	getUserAdDirectManager(token: string): Observable<any> {
		return this.httpClient.get(`${this.graphMeEndpoint}/me/manager`, {
			headers: { Authorization: `Bearer ${token}` },
		});
	}

	getUserAdDirectReports(token: string): Observable<any> {
		return this.httpClient.get(`${this.graphMeEndpoint}/me/directReports`, {
			headers: { Authorization: `Bearer ${token}` },
		});
	}

	getProfilePicture(token: string): Promise<any> {
		return this.httpClient
			.get(`${this.graphMeEndpoint}/me/photo/$value`, {
				headers: { Authorization: `Bearer ${token}` },
				responseType: 'blob',
			})
			.toPromise();
	}

	// getTeamProfilePic(upn: string, token: string): Promise<Blob | undefined> {

	//   return this.httpClient.get(`${this.graphMeEndpoint}/users/${upn}/photo/$value`, {
	//     headers: { 'Authorization': `Bearer ${token}` },
	//     responseType: 'blob'
	//   }).toPromise();

	// }

	getTeamProfilePicObservable(upn: string, token: string): Observable<Blob | undefined> {
		return this.httpClient.get(`${this.graphMeEndpoint}/users/${upn}/photo/$value`, {
			headers: { Authorization: `Bearer ${token}` },
			responseType: 'blob',
		});
	}

	getUserExists(upn: string, token: string): Observable<any> {
		return this.httpClient.get(
			`${this.graphMeEndpoint}/users?$select=id,businessPhones,displayName,givenName,jobTitle,mail,AccountEnabled&$filter=startswith(userPrincipalName,'${upn}')`,
			{
				headers: { Authorization: `Bearer ${token}` },
			}
		);
	}

	pruneManagedUsers() {
		return this.httpClient.post(`${this.profileUrl}/pruneManagedUsers`, this.httpOptions);
	}

	setUsersInactive(userIds: number[]): Observable<User[]> {
		return this.httpClient.post<User[]>(`${this.profileUrl}/setUsersInactive`, userIds, this.httpOptions);
	}

	saveMemberProfile(config: Configuration) {
		return this.httpClient.post(this.profileUrl, config, this.httpOptions);
	}

	updateMemberProfile(config: UpdateMemberConfig) {
		return this.httpClient.put(this.profileUrl, config, this.httpOptions);
	}
}
